import { useCallback, useMemo, useState } from 'react';

import { EMedicalCategoryType } from '@/entities/medical-category';
import { TreatmentRequest, TreatmentRequestForm, WebDiagnosisTreatmentRequestPageQueries } from '@/models/diagnosis';
import { EDoctorSortType } from '@/models/doctor/telemedicine';
import { parseDeprecatedMedicalCategoryCategoryTypeOf } from '@/parsers/common';
import { parseTreatmentRequestFormData } from '@/parsers/diagnosis';
import { EDiagnosisContactType } from '@/types/diagnosis';

interface UseTelemedicineFormStateParams {
  queries: WebDiagnosisTreatmentRequestPageQueries;
}

export const useTelemedicineFormState = ({ queries }: UseTelemedicineFormStateParams) => {
  const { type, categoryId, sortKey = EDoctorSortType.DEFAULT, inflowType = null } = queries;

  const parsedDeprecatedCategoryType = parseDeprecatedMedicalCategoryCategoryTypeOf(
    type ?? EMedicalCategoryType.TREATMENT
  );

  const [treatmentRequestForm, setTreatmentRequestForm] = useState<TreatmentRequestForm>(
    parseTreatmentRequestFormData({
      doctorId: '',
      categoryType: parsedDeprecatedCategoryType,
      categoryId,
      targetDate: '',
      inflowType,
      contactType: EDiagnosisContactType.NonF2F,
      sortKey,
    })
  );

  const treatmentRequest = useMemo(() => new TreatmentRequest(treatmentRequestForm), [treatmentRequestForm]);

  const updateForm = useCallback((updater: (prev: TreatmentRequestForm) => TreatmentRequestForm) => {
    setTreatmentRequestForm(updater);
  }, []);

  const updateFormFromTreatmentRequest = useCallback((request: TreatmentRequest) => {
    setTreatmentRequestForm(request.getForm());
  }, []);

  return {
    treatmentRequestForm,
    treatmentRequest,
    setTreatmentRequestForm,
    updateForm,
    updateFormFromTreatmentRequest,
  };
};
